import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenInput", "selectedBadge"]

  connect() {
    const option = this.element.querySelector(`[data-role-value="${this.hiddenInputTarget.value}"]`)
    if (option) this.select({ currentTarget: option })
  }

  select(event) {
    const selectedElement = event.currentTarget
    const roleValue = selectedElement.dataset.roleValue

    // Update hidden input value
    this.hiddenInputTarget.value = roleValue

    // Remove selected state from all options
    const allOptions = this.element.querySelectorAll('[data-action="click->ai-role-selector#select"]')
    allOptions.forEach(option => {
      option.classList.remove('bg-[#F2F3F5]')
      option.classList.add('bg-white')
      const badge = option.querySelector('[data-ai-role-selector-target="selectedBadge"]')
      if (badge) badge.remove()
    })

    // Add selected state to clicked option
    selectedElement.classList.remove('bg-white')
    selectedElement.classList.add('bg-[#F2F3F5]')

    const contentDiv = selectedElement.querySelector('.flex-1')
    if (contentDiv) {
      if (!contentDiv.classList.contains('relative')) {
        contentDiv.classList.add('relative', 'pr-20')
      }
      const badge = document.createElement('div')
      badge.className = 'absolute right-0 top-0.5 flex items-center gap-0.5 px-1.5 py-0.5 bg-[#ECFDF3] border border-[#ABEFC6] rounded-full'
      badge.setAttribute('data-ai-role-selector-target', 'selectedBadge')
      badge.innerHTML = '<span class="text-xs font-medium leading-5 text-[#067647]">Selected</span>'
      contentDiv.appendChild(badge)
    }
  }
}
